module.exports = __webpack_public_path__ + "img/device-management.cdb25748.webp";